"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_svg_1 = require("react-native-svg");
const Delete = (props) => {
    const { width, height, color } = props;
    return (react_1.default.createElement(react_native_svg_1.Svg, { width: width, height: height, viewBox: "0 0 15 17" },
        react_1.default.createElement(react_native_svg_1.Path, { fill: color, fillRule: "nonzero", d: "M0 2.79v-.93c0-.442.358-.798.804-.798h3.75l.314-.62A.795.795 0 0 1 5.585 0h3.827c.305 0 .582.17.72.442l.314.62h3.75c.446 0 .804.356.804.797v.93c0 .22-.18.398-.402.398H.402A.401.401 0 0 1 0 2.79zm13.929 1.858v10.758A1.6 1.6 0 0 1 12.32 17H2.68a1.6 1.6 0 0 1-1.608-1.594V4.648c0-.219.181-.398.402-.398h12.054c.22 0 .402.18.402.398zM4.82 6.906a.535.535 0 0 0-1.071 0v7.438a.535.535 0 0 0 1.071 0V6.906zm3.215 0a.535.535 0 0 0-1.072 0v7.438a.535.535 0 0 0 1.072 0V6.906zm3.214 0a.535.535 0 0 0-1.071 0v7.438a.535.535 0 0 0 1.071 0V6.906z" })));
};
Delete.defaultProps = {
    color: 'currentColor',
    width: 16,
    height: 17,
};
exports.default = react_1.default.memo(Delete);
